import ErrorMessage from './ErrorMessage';
import { ErrorMessageTitle, ErrorMessageDetails } from './components';

ErrorMessage.Title = ErrorMessageTitle;
ErrorMessage.Details = ErrorMessageDetails;

export {
  ErrorMessageTitle,
  ErrorMessageDetails,
};

export default ErrorMessage;
